export const pl = {
    'buttons': {
        'return': 'Wróć'
    },
    'selects': {
        'currency': {
            'label': 'Waluta',
            'placeholder': 'Wybierz walutę',
            'options-title': 'Lista dostępnych monet'
        },
        'currency-and-network': {
            'placeholder': 'Wybierz walutę i sieć',
            'options-title': 'Lista dostępnych monet'
        },
        'selected-label': 'Wybrano: {selected} z {length}',
        'search': 'Szukaj',
        'errors': {
            'invalid': 'Nieprawidłowa wartość',
            'required': 'Wymagane',
            'card-holder': 'Wprowadź imię i nazwisko właściciela karty',
            'input-amount': 'Wprowadź kwotę',
            'fill-card': 'Uzupełnij dane karty'
        },
        'empty-list': 'Pusta lista',
        'address': {
            'label': 'Adres wypłaty w {currency}',
            'options-title': 'Lista dostępnych adresów'
        },
        'cardholder-input': {
            'placeholder': 'Właściciel karty'
        }
    },
    'text-fields': {
        'labels': {
            'personal': {
                'address': 'Twój adres do wpłaty'
            },
            'invoice': {
                'address': 'Adres',
                'paid-amount': 'Zapłacona kwota'
            }
        }
    },
    'labels': {
        'deposit': 'Depozyt',
        'withdraw': 'Wypłata',
        'currency': 'Waluta',
        'amount': 'Kwota',
        'invoice': {
            'remaining-time': 'Pozostały czas na płatność',
            'status': {
                'expires': 'Czas minął',
                'success': 'Płatność pomyślna',
                'error': 'Błąd'
            },
            'partially-paid': {
                'title': 'Częściowo opłacone',
                'info': 'Kwota została częściowo opłacona. Aby płatność była pomyślna, należy wpłacić pozostałą kwotę.'
            },
            'orphan': {
                'title': 'Osierocona transakcja',
                'description': 'Jedna z transakcji w tym zamówieniu zawiera niewłaściwą sieć lub walutę.',
                'contact': 'Skontaktuj się z pomocą techniczną, podając ID:'
            },
            'you-paid': 'Zapłaciłeś',
            'active-order': 'Aktywne zamówienie',
            'new-invoice': 'Nowa faktura',
            'order-id': 'ID faktury',
            'payment-amount': 'Kwota płatności'
        },
        'continue': 'Kontynuuj',
        'payout': {
            'address': 'Adres wypłaty w {currency}',
            'tag-or-memo': 'TAG lub MEMO',
            'status': {
                'processed': 'Pomyślnie',
                'error': 'Błąd',
                'orphan': 'Osierocona transakcja',
                'approve_rejected': 'Odrzucono',
                'in-progress': 'W toku',
                'need-approve': 'Wymaga zatwierdzenia',
                'awaiting-confirmation': 'Twoje żądanie wypłaty oczekuje na potwierdzenie'
            },
            'info': {
                'withdraw-id': 'ID wypłaty',
                'tx-hash': 'TX hash',
                'currency-and-network': 'Waluta i sieć',
                'address': 'Adres',
                'tag-or-memo': 'TAG lub MEMO',
                'amount': 'Kwota do wypłaty'
            }
        },
        'fiat': {
            'title': 'Depozyt przez fiat',
            'info': {
                'amount': 'Kwota',
                'date': 'Data płatności',
                'id': 'ID depozytu',
                'system': 'System płatności'
            },
            'status': {
                'new': 'Nowy',
                'pending': 'Oczekujący',
                'authorized': 'Autoryzowany',
                'confirmed': 'Potwierdzony',
                'reconciled': 'Uzgodniony',
                'error': 'Błąd',
                'declined': 'Odrzucony'
            }
        }
    },
    'errors': {
        'wrong-widget-id': 'Nieprawidłowy ID widgetu',
        'wrong-ext-user-id': 'Nieprawidłowy zewnętrzny ID użytkownika',
        '404': 'Ups! Szukaliśmy, ale nie znaleźliśmy tego, czego szukasz.',
        'without-xt-user-id-withdrawal': 'Wypłata niedostępna. Parametr extUserId nie został przekazany',
        'without-xt-user-id-deposit': 'Depozyt niedostępny. Parametr extUserId nie został przekazany'
    },
    'invoice': {
        'order': 'Zamówienie',
        'inputs': {
            'email': {
                'label': 'Adres e-mail',
                'placeholder': 'Wprowadź swój adres e-mail'
            },
            'amount': {
                'label': 'Kwota',
                'placeholder': 'Wprowadź kwotę'
            }
        },
        'text-fields': {
            'expanded': {
                'in-usd': 'Kwota w',
                'rate': 'Kurs wymiany',
                'payment-id': 'ID płatności',
                'description': 'Opis'
            }
        },
        'order-public-link': {
            'do-not-refresh': 'Nie odświeżaj strony ani nie otwieraj faktury w',
            'new-tab': 'nowej karcie'
        },
        'statuses': {
            'ERROR': 'BŁĄD',
            'PENDING': 'OCZEKUJĄCY',
            'PROCESSED': 'PRZETWORZONY',
            'REJECTED': 'ODRZUCONY',
            'OVERPAID': 'PRZEPŁACONY',
            'CREATED': 'UTWORZONY',
            'PARTIAL': 'CZĘŚCIOWO OPŁACONY',
            'INIT': 'ZAINICJOWANY',
            'EXPIRED': 'PRZETERMINOWANY'
        }
    },
    'personal': {
        'titles': {
            'deposit': 'Depozyt',
            'payment-history': 'Historia płatności'
        },
        'payment-history': {
            'empty-label': 'Wszystkie Twoje transakcje wysłane na wskazany adres będą dostępne tutaj',
            'headers': {
                'date': 'Data i godzina',
                'amount': 'Kwota',
                'tx': 'Tx_hash',
                'status': 'Status'
            },
            'statuses': {
                'processed': 'Przetworzony',
                'pending': 'Oczekujący',
                'rejected': 'Odrzucony',
                'error': 'Błąd'
            },
            'in': 'w'
        },
        'qr-block': {
            'empty-label': 'Doładowanie kryptowalutą',
            'qr-info-pre-invoice': 'Wysyłaj tylko',
            'qr-info-pre-personal': 'Wyślij dowolną kwotę tylko w',
            'qr-info-post': 'na ten adres',
            'qr-info-minimal': 'Przelewy na kwotę mniejszą niż 1 USD nie są zaksięgowane'
        }
    },
    'fiat': {
        'titles': {
            'deposit': 'Depozyt przez fiat',
            'payment-history': 'Historia płatności'
        },
        'labels': {
            'pay': 'Zapłać',
            'service-commission': 'Kwota prowizji za usługę',
            'total': 'Razem',
            'you-pay': 'Płacisz'
        }
    },
    'popup': {
        'orphan-danger': {
            'title': 'Osierocona transakcja',
            'info': 'Jedna z transakcji w tym zamówieniu zawiera niewłaściwą sieć lub walutę.',
            'support': 'Skontaktuj się z pomocą techniczną, podając ID'
        }
    },
    'cookie-policy': {
        'by-clicking': 'Klikając przycisk „Kontynuuj”, automatycznie zgadzasz się na',
        'our': 'naszą politykę plików cookie'
    },
    'payout': {
        'payout': 'Wypłata',
        'output': 'Wypłata',
        'withdraw': 'Wypłata',
        'errors': {
            'wrong-address': 'Adres nie należy do sieci {network}'
        }
    }
}
